import React from "react";
import {
  AutoplaySlider,
  IndividualSlide,
  SlideImage,
  SliderContainer,
  SliderWrapper,
  SlideTrack,
} from "components/styled/SliderElements";
import slides from "./slides";

function InfiniteSlider() {
  const infiniteSlides = slides.map((slide) => (
    <IndividualSlide key={slide.name}>
      <SlideImage src={slide.imagePath} alt={slide.name} />
    </IndividualSlide>
  ));

  return (
    <SliderWrapper>
      <SliderContainer>
        <AutoplaySlider>
          <SlideTrack>{infiniteSlides}</SlideTrack>
          <SlideTrack>{infiniteSlides}</SlideTrack>
        </AutoplaySlider>
      </SliderContainer>
    </SliderWrapper>
  );
}

export default InfiniteSlider;
